module.exports = __webpack_public_path__ + "static/media/MM.f236f3e3.png";